<template>
  <div class="home">
    <div class="wrapper">
      <div class="table-wrapper">
        <div class="palace-cell">
          <palace-component
            :palace="pan.palace[5]"
            palace-id="5"
            ref="palace5"
            v-if="init && !isClass"
          />
          <class-palace-component
            :palace="pan.palace[5]"
            palace-id="5"
            ref="palace5"
            v-else-if="init"
          />
        </div>
        <div class="palace-cell">
          <palace-component
            :palace="pan.palace[4]"
            palace-id="4"
            ref="palace4"
            v-if="init && !isClass"
          />
          <class-palace-component
            :palace="pan.palace[4]"
            palace-id="4"
            ref="palace4"
            v-else-if="init"
          />
        </div>
        <div class="palace-cell">
          <palace-component
            :palace="pan.palace[3]"
            palace-id="3"
            ref="palace3"
            v-if="init && !isClass"
          />
          <class-palace-component
            :palace="pan.palace[3]"
            palace-id="3"
            ref="palace3"
            v-else-if="init"
          />
        </div>
        <div class="palace-cell palace-cell-bottom">
          <palace-component
            :palace="pan.palace[2]"
            palace-id="2"
            ref="palace2"
            v-if="init && !isClass"
          />
          <class-palace-component
            :palace="pan.palace[2]"
            palace-id="2"
            ref="palace2"
            v-else-if="init"
          />
        </div>
      </div>
      <div class="table-wrapper table-middle-wrapper">
        <div class="table-middle-cell">
          <div class="palace-cell">
            <palace-component
              :palace="pan.palace[6]"
              palace-id="6"
              ref="palace6"
              v-if="init && !isClass"
            />
            <class-palace-component
              :palace="pan.palace[6]"
              palace-id="6"
              ref="palace6"
              v-else-if="init"
            />
          </div>
          <div class="palace-cell">
            <palace-component
              :palace="pan.palace[7]"
              palace-id="7"
              ref="palace7"
              v-if="init && !isClass"
            />
            <class-palace-component
              :palace="pan.palace[7]"
              palace-id="7"
              ref="palace7"
              v-else-if="init"
            />
          </div>
        </div>
        <div class="table-middle-cell table-middle-center-cell">
          <div class="data-cell">
            <div class="main-data" :style="[isClass ? 'fontSize: 20px' : '']">
              <div><strong>求真易学社</strong></div>
              <div v-if="init">
                <div><strong>钟表时间</strong>：<br />{{ user.birthday }}</div>
                <div>
                  <strong>真太阳时</strong>：<br />{{ apparentSolarTime }}
                </div>
                <div><strong>阴历生日</strong>：{{ lunarBirthday }}</div>
                <div>
                  <strong>性别</strong>：{{
                    gender == 1 ? '男' : '女'
                  }}，<strong>虚岁</strong>：{{ age }}
                </div>
                <div><strong>出生地</strong>：{{ areaName }}</div>
                <div>
                  <button @click="toInput()">重新输入</button>
                </div>
              </div>
            </div>
            <div
              style="
                background-image: url('/image/80M.png');
                background-repeat: no-repeat;
                background-position: center;
                background-size: contain;
                flex-grow: 1;
                max-height: 66px;
              "
              v-if="!isClass"
            ></div>
            <div
              style="
                background-image: url('/image/80M-c.png');
                background-repeat: no-repeat;
                background-position: center;
                background-size: contain;
                flex-grow: 1;
                max-height: 132px;
              "
              v-else
            ></div>
            <div class="copyright-data">吴明光老师版权所有</div>
          </div>
        </div>
        <div class="table-middle-cell">
          <div class="palace-cell palace-cell-bottom">
            <palace-component
              :palace="pan.palace[1]"
              palace-id="1"
              ref="palace1"
              v-if="init && !isClass"
            />
            <class-palace-component
              :palace="pan.palace[1]"
              palace-id="1"
              ref="palace1"
              v-else-if="init"
            />
          </div>
          <div class="palace-cell palace-cell-bottom">
            <palace-component
              :palace="pan.palace[0]"
              palace-id="0"
              ref="palace0"
              v-if="init && !isClass"
            />
            <class-palace-component
              :palace="pan.palace[0]"
              palace-id="0"
              ref="palace0"
              v-else-if="init"
            />
          </div>
        </div>
      </div>
      <div class="table-wrapper">
        <div class="palace-cell palace-cell-right">
          <palace-component
            :palace="pan.palace[8]"
            palace-id="8"
            ref="palace8"
            v-if="init && !isClass"
          />
          <class-palace-component
            :palace="pan.palace[8]"
            palace-id="8"
            ref="palace8"
            v-else-if="init"
          />
        </div>
        <div class="palace-cell palace-cell-right">
          <palace-component
            :palace="pan.palace[9]"
            palace-id="9"
            ref="palace9"
            v-if="init && !isClass"
          />
          <class-palace-component
            :palace="pan.palace[9]"
            palace-id="9"
            ref="palace9"
            v-else-if="init"
          />
        </div>
        <div class="palace-cell palace-cell-right">
          <palace-component
            :palace="pan.palace[10]"
            palace-id="10"
            ref="palace10"
            v-if="init && !isClass"
          />
          <class-palace-component
            :palace="pan.palace[10]"
            palace-id="10"
            ref="palace10"
            v-else-if="init"
          />
        </div>
        <div class="palace-cell palace-cell-right palace-cell-bottom">
          <palace-component
            :palace="pan.palace[11]"
            palace-id="11"
            ref="palace11"
            v-if="init && !isClass"
          />
          <class-palace-component
            :palace="pan.palace[11]"
            palace-id="11"
            ref="palace11"
            v-else-if="init"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import moment from 'moment-timezone'
import axios from 'axios'

import { PanUtil } from '@/util'
import PalaceComponent from '@/components/PalaceComponent.vue'
import ClassPalaceComponent from '@/components/ClassPalaceComponent.vue'
import { AREAS } from '@/constant/china'
import { CHINESE_NEW_YEAR } from '@/constant/chinese-new-year'

export default {
  name: 'HomeView',
  data: function () {
    return {
      currentYear: 1970,
      currentMonth: 7,
      currentDay: 15,
      currentHour: 12,
      currentMinute: 0,
      gender: '1',
      selectArea: '110000',
      apparentSolarTime: '',
      daylight: 0,
      pan: {},
      init: false,
    }
  },
  components: {
    PalaceComponent,
    ClassPalaceComponent,
  },
  created: async function () {
    // 首先获取视窗高度，再乘以1%得到vh单位的值
    let vh = window.innerHeight * 0.01
    // 把--vh的值设置到文档的根元素中
    document.documentElement.style.setProperty('--vh', `${vh}px`)

    if (window.localStorage.getItem('user') !== null) {
      const user = JSON.parse(window.localStorage.getItem('user'))
      const date = moment.tz(user.birthday, 'YYYY-MM-DD HH:mm', 'Etc/GMT-8')

      this.currentYear = date.year()
      this.currentMonth = date.month() + 1
      this.currentDay = date.date()

      this.currentHour = date.hour()
      this.currentMinute = date.minute()

      this.gender = user.gender

      this.selectArea = user.location || 110000

      this.daylight = user.daylight || 0
    }

    await this.getPan()
    this.init = true
  },
  mounted: async function () {},
  computed: {
    user: function () {
      const birthday = moment.tz(
        this.birthdayDate +
          ' ' +
          String(this.currentHour).padStart(2, '0') +
          ':' +
          String(this.currentMinute).padStart(2, '0'),
        'YYYY-MM-DD HH:mm',
        'Etc/GMT-8'
      )

      return {
        birthday: birthday.format('YYYY-MM-DD HH:mm'),
        gender: this.gender,
        location: this.selectArea,
        daylight: this.daylight,
      }
    },
    birthdayDate: function () {
      const d =
        this.currentYear + '-' + this.currentMonth + '-' + this.currentDay
      return d
    },
    isClass: function () {
      return process.env.VUE_APP_USE_STARS === 'CLASS'
    },
    areaLevel1: function () {
      return AREAS.filter(function (item) {
        return item.level == 1
      })
    },
    areaLevel2: function () {
      return AREAS.filter(function (item) {
        return item.level == 2
      })
    },
    areaLevel3: function () {
      return AREAS.filter(function (item) {
        return item.level == 3
      })
    },
    areaName: function () {
      const location = AREAS.find((item) => item.code == this.selectArea)
      if (location.level == 3) {
        const level2 = this.areaLevel2.find(
          (item) => item.code == location.parentCode
        )
        const level1 = this.areaLevel1.find(
          (item) => item.code == level2.parentCode
        )
        return level1.name + '-' + level2.name + '-' + location.name
      } else if (location.level == 2) {
        const level1 = this.areaLevel1.find(
          (item) => item.code == location.parentCode
        )
        return level1.name + '-' + location.name
      }
      return location.name
    },
    age: function () {
      const lunarBirthDate = this.pan.birthdayLunar1.split(' ')[0]
      const year = lunarBirthDate.split('/')[0]

      const now = moment().tz('Etc/GMT-8')
      let thisYear = now.year()
      const chineseNewYearDate = CHINESE_NEW_YEAR[now.year()]
      const chineseNewYear = moment(
        new Date(now.year(), chineseNewYearDate[0] - 1, chineseNewYearDate[1])
      ).tz('Etc/GMT-8')
      if (now.isBefore(chineseNewYear)) {
        thisYear--
      }

      const age = thisYear - year + 1

      return age
    },
    lunarBirthday: function () {
      const lunarBirthDate = this.pan.birthdayLunar1.split(' ')[0]
      const year = lunarBirthDate.split('/')[0]
      const month = lunarBirthDate.split('/')[1]
      const date = lunarBirthDate.split('/')[2]
      return PanUtil.getLunarChineseDate(year, month, date, this.pan.isLeap)
    },
    fiveElement: function () {
      if (this.pan.FiveElement == 2) {
        return '水二局'
      } else if (this.pan.FiveElement == 3) {
        return '木三局'
      } else if (this.pan.FiveElement == 4) {
        return '金四局'
      } else if (this.pan.FiveElement == 5) {
        return '土五局'
      } else if (this.pan.FiveElement == 6) {
        return '火六局'
      } else return ''
    },
  },
  methods: {
    submit: async function () {
      await this.getPan()
      this.$refs.palace0.resetFontSize()
      this.$refs.palace1.resetFontSize()
      this.$refs.palace2.resetFontSize()
      this.$refs.palace3.resetFontSize()
      this.$refs.palace4.resetFontSize()
      this.$refs.palace5.resetFontSize()
      this.$refs.palace6.resetFontSize()
      this.$refs.palace7.resetFontSize()
      this.$refs.palace8.resetFontSize()
      this.$refs.palace9.resetFontSize()
      this.$refs.palace10.resetFontSize()
      this.$refs.palace11.resetFontSize()
    },
    getApparentSolarTime: async function () {
      const cloneBirthday = moment.tz(
        this.user.birthday,
        'YYYY-MM-DD HH:mm',
        'Etc/GMT-8'
      )
      if (this.daylight == 1) {
        cloneBirthday.hour(cloneBirthday.hour() - 1)
      }

      let location = AREAS.find((item) => item.code == this.selectArea)
      if (!location) {
        this.selectArea = 110000
        location = AREAS.find((item) => item.code == this.selectArea)
      }
      while (!location.longitude) {
        location = AREAS.find((item) => item.code == location.parentCode)
      }

      const payload = {
        year: cloneBirthday.year(),
        month: cloneBirthday.month() + 1,
        date: cloneBirthday.date(),
        hour: cloneBirthday.hour(),
        minute: cloneBirthday.minute(),
        longitude: location.longitude,
        timezone: 'Asia/Shanghai',
      }

      const { data: resp } = await axios.get(
        'https://api-util.taotaoxi.cn/apparent-solar-time',
        {
          params: payload,
        }
      )

      const ret =
        resp.year +
        '/' +
        resp.month +
        '/' +
        resp.date +
        ' ' +
        String(resp.hour).padStart(2, '0') +
        ':' +
        String(resp.minute).padStart(2, '0')

      this.apparentSolarTime =
        resp.year +
        '-' +
        resp.month +
        '-' +
        resp.date +
        ' ' +
        String(resp.hour).padStart(2, '0') +
        ':' +
        String(resp.minute).padStart(2, '0')

      return ret
    },
    getPan: async function () {
      // let trueSolarTime = await this.getApparentSolarTime()

      // thisYear: moment().tz('Etc/GMT-8').year(),

      let location = AREAS.find((item) => item.code == this.selectArea)
      if (!location) {
        this.selectArea = 110000
        location = AREAS.find((item) => item.code == this.selectArea)
      }
      while (!location.longitude) {
        location = AREAS.find((item) => item.code == location.parentCode)
      }

      const now = moment().tz('Etc/GMT-8')
      let thisYear = now.year()
      const chineseNewYearDate = CHINESE_NEW_YEAR[now.year()]
      const chineseNewYear = moment(
        new Date(now.year(), chineseNewYearDate[0] - 1, chineseNewYearDate[1])
      ).tz('Etc/GMT-8')
      if (now.isBefore(chineseNewYear)) {
        thisYear--
      }
      const payload = {
        thisYear: thisYear,
        name: '小明',
        gender: this.user.gender,
        birthday: this.user.birthday,
        longitude: location.longitude,
        timezone: 'Asia/Shanghai',
        daylight: this.user.daylight,
      }
      const resp = await axios.post(
        // 'http://bryanwu.taotaoxi.cn/AIFortuneTeller/GetOneLifePan',
        'https://api.taotaoxi.cn/ming-pan/get-pan/v3',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            'x-ca-stage': 'TEST',
          },
        }
      )

      this.pan = { ...resp.data, palace: PanUtil.processPalace(resp.data) }
      this.apparentSolarTime = resp.data.apparentSolarTime

      // let re = new RegExp('鹹', 'g')

      // const cnString = tw2cn(JSON.stringify(this.pan)).replace(re, '咸')

      // this.pan = JSON.parse(cnString)

      window.localStorage.setItem('user', JSON.stringify(this.user))
    },
    toInput: function () {
      this.$router.push({ name: 'InputData' })
    },
  },
}
</script>

<style>
.home {
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  overflow: hidden;
  display: flex;
  font-size: 14px;
}

.wrapper {
  margin: 10px;
  flex: 1;
  display: flex;
}

.table-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.table-middle-wrapper {
  flex: 2;
}
.table-middle-cell {
  display: flex;
  flex: 1;
}
.table-middle-center-cell {
  flex: 2;
}

.data-cell {
  border: 1px solid black;
  border-bottom: none;
  border-right: none;
  flex: 1;
  padding: 5px;
  display: flex;
  flex-direction: column;
}
.main-data {
  flex: 1;
  font-size: 12px;
}

.palace-cell {
  flex: 1;
  border: 1px solid black;
  border-bottom: none;
  border-right: none;
  display: flex;
  padding: 1px;
  position: relative;
}
.palace-cell-right {
  border-right: 1px solid black;
}

.palace-cell-bottom {
  border-bottom: 1px solid black;
}
.copyright-data {
  font-size: 12px;
}
.inline-block {
  display: inline-block;
}
.birthday-input {
  border: 1px solid rgb(118, 118, 118);
  height: 1.2em;
  width: 85%;
  margin: 0 auto;
}
</style>
